import React from 'react';
import * as style from './style.module.scss';
import { SprucesLeft, SprucesRight } from '../Trees';
import Player from '../Player';

interface HeaderProps {
  title: string;
  song: {
    title: string;
    image: any;
    imageAlt: string;
    url: string;
  };
}

const Header = ({ title, song }: HeaderProps) => {
  const pageTitle = title.split(' ');

  return (
    <header className={style.header}>
      <SprucesLeft />
      <SprucesRight />
      <div className={style.header__content}>
        <Player song={song} />
        <h1 className={style.header__title}>
          <span className={style.header__title_1}>
            {pageTitle[0]}
          </span>{' '}
          <span className={style.header__title_2}>
            {pageTitle[1]}
          </span>
        </h1>
      </div>
    </header>
  );
};

export default Header;
